import mangoImages from "../data/mangoImages.json";
import { mangoImagePath } from "../seo/builders";

/**
 * Get a dummy/placeholder image URL if the provided image URL is invalid or fails to load
 */
export const getDummyImageUrl = (): string => {
  // Using a placeholder service or a data URI for a mango emoji
  // You can replace this with any placeholder image service
  return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400'%3E%3Crect fill='%23fbbf24' width='400' height='400'/%3E%3Ctext x='50%25' y='50%25' font-size='120' text-anchor='middle' dominant-baseline='middle'%3E🥭%3C/text%3E%3C/svg%3E";
};

/**
 * Check if an image URL is valid and handle errors
 */
export const handleImageError = (
  e: React.SyntheticEvent<HTMLImageElement, Event>
): void => {
  const img = e.currentTarget;
  if (img.src !== getDummyImageUrl()) {
    img.src = getDummyImageUrl();
  }
};

/**
 * Get a safe image URL - returns dummy image if URL is invalid
 */
export const getSafeImageUrl = (imageUrl: string | undefined | null): string => {
  if (!imageUrl || imageUrl.trim() === "") {
    return getDummyImageUrl();
  }
  return imageUrl;
};

/**
 * Map mango name to its corresponding image path in the public folder
 * Returns the image path if found, otherwise returns null
 */
export const getMangoImagePath = (mangoName: string): string | null =>
  mangoImagePath(mangoName, mangoImages);


/**
 * Get mango image URL - tries mapped image first, then falls back to provided imageUrl or dummy
 */
export const getMangoImageUrl = (
  mangoName: string,
  imageUrl?: string | null
): string => {
  // First, try to get the mapped image from public folder
  const mappedImage = getMangoImagePath(mangoName);
  if (mappedImage) {
    return mappedImage;
  }

  // If no mapped image, use the provided imageUrl
  if (imageUrl) {
    return getSafeImageUrl(imageUrl);
  }

  // Fallback to dummy image
  return getDummyImageUrl();
};

